import { render, staticRenderFns } from "./CampaignVoting.vue?vue&type=template&id=359a1f5d"
import script from "./CampaignVoting.vue?vue&type=script&lang=js"
export * from "./CampaignVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports